import { injectStyle } from './style';
export const createDropdown = (utils) => {
    const div = document.createElement('div');
    div.setAttribute('role', 'listbox');
    div.setAttribute('tabindex', '-1');
    const style = utils.getStyle(injectStyle);
    if (style) {
        div.classList.add(style);
    }
    div.classList.add('slash-dropdown', 'hide');
    return div;
};
export const createDropdownItem = (themeTool, text, icon, options) => {
    var _a;
    const textClassName = (_a = options === null || options === void 0 ? void 0 : options.textClassName) !== null && _a !== void 0 ? _a : 'text';
    const div = document.createElement('div');
    div.setAttribute('role', 'option');
    div.classList.add('slash-dropdown-item');
    const iconSpan = themeTool.slots.icon(icon);
    const textSpan = document.createElement('span');
    textSpan.textContent = text;
    textSpan.className = textClassName;
    div.appendChild(iconSpan);
    div.appendChild(textSpan);
    return div;
};
export const getDepth = (node) => {
    let cur = node;
    let depth = 0;
    while (cur.childCount) {
        cur = cur.child(0);
        depth += 1;
    }
    return depth;
};
const cleanUp = (state, dispatch) => {
    const { selection } = state;
    const { $from } = selection;
    const tr = state.tr.deleteRange($from.start(), $from.pos);
    dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
    return false;
};
export const cleanUpAndCreateNode = (createCommand) => (state, dispatch, view) => {
    if (view) {
        cleanUp(state, dispatch, view);
        createCommand();
    }
    return true;
};
export const nodeExists = (name) => (schema) => Boolean(schema.nodes[name]);
//# sourceMappingURL=utility.js.map